<!--销售订单列表  -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="showSearchDialog">查询 (F2)</el-button>
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="add(0)" v-if="permission.add">{{ permission.add }} (F3)</el-button>

                <el-button v-if="permission.print && !isDefaultSet" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()">{{
                    permission.print
                }}</el-button>
                <el-button v-if="permission.printPreview && !isDefaultSet" size="small" icon="el-icon-view" class="search-btn btn-primary" @click="printPreview()">{{
                    permission.printPreview
                }}</el-button>
                <el-button
                    v-if="(permission.printPreview || permission.print) && isDefaultSet"
                    size="small"
                    icon="el-icon-printer"
                    class="search-btn btn-primary"
                    @click="printPreview()"
                    >打印</el-button
                >
                <el-button v-if="permission.printEng" size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="printEng()">{{
                    permission.printEng
                }}</el-button>
                <el-button v-if="permission.export" size="small" icon="el-icon-download" class="search-btn btn-primary" @click="exportForm()">{{
                    permission.export
                }}</el-button>
                <el-button v-if="permission.exportEng" size="small" icon="el-icon-download" class="search-btn btn-primary" @click="exportEngForm()">{{
                    permission.exportEng
                }}</el-button>
                <el-button v-if="permission.importCreateOrder" size="small" class="search-btn btn-primary" @click="gotoImportCreatePage">
                    <i class="fa fa-file-excel-o"></i>
                    {{ permission.importCreateOrder }}
                </el-button>
                <el-button size="small" icon="el-icon-document" class="search-btn btn-primary" @click="history()" v-if="permission.history">{{
                    permission.history
                }}</el-button>
                <el-button size="small" class="search-btn btn-primary" @click="showSearch()" v-if="permission.searchAP">搜索配件</el-button>
            </div>
            <div class="search-ctn-right" v-if="summaryStr">
                <div class="section-summary">
                    <div>
                        <span>{{ summaryStr }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-ctn sales-order-table">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                border=""
                style="width: 100%"
                @cell-dblclick="handleDBClick"
                :tableCode="tableCode"
                @sort-change="sortChange"
                :row-key="getRowKeys"
                v-loading="loading"
                :summary-method="getSummaries"
                show-summary
            >
                <el-table-column type="selection" reserve-selection width="50"></el-table-column>
                <template v-for="(col, index) in columnShowSets">
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        :class-name="col.ColumnCode === 'OrderCode' ? 'ordercode-column' : ''"
                        v-if="col.ColumnCode == 'OrderCode'"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <img src="@/assets/images/chong.png" title="需要冲减" style="width: 20px; height: 20px; margin-right: 3px" v-if="scope.row.IsDeduct" />
                            <el-badge :value="'打印' + scope.row.PrintedCount + '次'" class="mark" type="danger" v-if="scope.row.PrintedCount > 0">
                                <el-tag @click="showOrderPreview(scope.row)" class="codetag"> {{ scope.row.OrderCode }}</el-tag>
                            </el-badge>
                            <el-tag v-if="scope.row.PrintedCount == 0" @click="showOrderPreview(scope.row)" class="codetag"> {{ scope.row.OrderCode }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else-if="col.ColumnCode == 'CollectionStateName'"
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.CollectionStateName == '已收款'" class="c-active">{{ scope.row.CollectionStateName }}</i>
                            <i v-else>{{ scope.row.CollectionStateName }}</i>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else-if="col.ColumnCode == 'WarehouseName'"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.WarehouseName }}
                            <span style="color: #8492a6" v-if="scope.row.WarehouseType == 1">(前置仓)</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else-if="col.ColumnCode == 'OutWarehouseStateName'"
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.OutWarehouseStateName == '已出仓'" class="out-active">{{ scope.row.OutWarehouseStateName }}</i>
                            <i v-else-if="scope.row.OutWarehouseStateName == '部分出仓'" class="cancel-active">{{ scope.row.OutWarehouseStateName }}</i>
                            <i v-else>{{ scope.row.OutWarehouseStateName }}</i>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-bind:key="col.ColumnCode + index"
                        :width="col.Width > 0 ? col.Width + 'px' : '150px'"
                        :label="col.ColumnName"
                        resizable
                        :sortable="col.IsSort ? 'custom' : false"
                        header-align
                        :prop="col.ColumnCode"
                        show-overflow-tooltip
                        v-else
                    >
                    </el-table-column>
                </template>
                <el-table-column fixed="right" label="操作" :isCanSet="true" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button v-if="permission.edit && scope.row.IsCanUpdate" title="编辑" size="mini" type="text" @click="add(2, scope.row)">{{
                                permission.edit
                            }}</el-button>
                            <el-button v-if="permission.submit && scope.row.IsCanUpdate" title="提交" size="mini" type="text" @click="submitOrder(scope.row)">{{
                                permission.submit
                            }}</el-button>
                            <el-button
                                v-if="permission.modifyOrder && (scope.row.IsCanUpdateAfterSubmit || (priceCanBeEdit ? scope.row.IsCanCollect : false))"
                                title="修改订单"
                                size="mini"
                                type="text"
                                @click="add(8, scope.row)"
                                >{{ permission.modifyOrder }}</el-button
                            >
                            <el-button
                                v-if="permission.cancel && scope.row.IsCanCancel"
                                title="取消"
                                size="mini"
                                type="text"
                                style="color: orange"
                                @click="cancel(scope.row)"
                                >{{ permission.cancel }}</el-button
                            >
                            <el-button v-if="permission.del && scope.row.IsCanDelete" title="删除" size="mini" type="text" style="color: red" @click="del(scope.row)"
                                >删除</el-button
                            >
                            <el-button v-if="permission.opRecords" title="操作记录" size="mini" type="text" @click="opRecords(scope.row)">{{
                                permission.opRecords
                            }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                v-if="tableDataLength != 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <!--  打印  -->
        <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="dialogVisible" width="870px">
            <div class="dialog-content" v-if="dialogVisible">
                <printSaleContent @closeDialog="closeDialog" :printIds="idList" :showDisc="showDisc" :isInit="true"> </printSaleContent>
            </div>
        </el-dialog>
        <!-- 打印隐藏内容，用于直接打印 -->
        <div style="visibility: hidden; width: 870px; position: absolute !important; top: -1000px !important" id="printDom" v-if="isRegister">
            <printSaleContent ref="printDom" @closeDialog="closeDialog" :printIds="idList" :showDisc="showDisc" :isInit="false"> </printSaleContent>
        </div>
        <!--  打印英文版  -->
        <el-dialog :close-on-click-modal="false" title="打印英文销售单" :visible.sync="dialogPrintEngVisible" width="870px">
            <div class="dialog-content" v-if="dialogPrintEngVisible">
                <printEngContent @closeDialog="closePrintEngDialog" :printIds="idList"></printEngContent>
            </div>
        </el-dialog>
        <!--   搜索配件    -->
        <el-dialog :close-on-click-modal="false" title="搜索配件" :visible.sync="searchVisible" width="1200px">
            <div v-if="searchVisible">
                <searchAP canEdit="canNot" Source="0" @closeDialog="closeSearchDialog"></searchAP>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="销售单的操作记录" :visible.sync="OrderLifesVisible" width="1000px">
            <div class="dialog-content" v-if="OrderLifesVisible">
                <ordersLifes :OrderId="OrderId" :OrderType="0" @closeDialog="closeOrderLifesDialog"></ordersLifes>
            </div>
        </el-dialog>
        <el-dialog
            :close-on-click-modal="false"
            title="销售订单搜索"
            :visible.sync="dialogSearchVisible"
            width="400px"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="search-order-dialog"
            custom-class="search-item-dialog"
            style="margin-left: -170px"
        >
            <div class="dialog-content" v-if="dialogSearchVisible">
                <el-form ref="form" label-position="left" label-width="70px">
                    <el-form-item label="国家">
                        <el-select
                            style="width: 100%"
                            size="small"
                            v-model="searchData.CountryId"
                            filterable
                            clearable
                            reserve-keyword
                            @change="countryChange($event)"
                            placeholder="请选择"
                            @visible-change="countryVisibleChange($event)"
                        >
                            <el-option label="全部" value></el-option>
                            <el-option
                                v-for="optionItem in countryList"
                                :key="optionItem.CountryId"
                                :data-msg="optionItem"
                                :label="optionItem.CountryName"
                                :value="optionItem.CountryId"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="来源店铺">
                        <el-select
                            style="width: 100%"
                            size="small"
                            v-model="searchData.ShopId"
                            filterable
                            clearable
                            reserve-keyword
                            @change="shopChange($event)"
                            @visible-change="shopVisibleChange($event)"
                            placeholder="请选择"
                        >
                            <el-option label="全部" value></el-option>
                            <el-option
                                v-for="optionItem in shopList"
                                :key="optionItem.Id"
                                :data-msg="optionItem"
                                :label="optionItem.Name"
                                :value="optionItem.Id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="客户名称">
                        <el-select
                            ref="search_cus"
                            style="width: 100%"
                            size="small"
                            v-model="searchData.Keyword"
                            remote
                            filterable
                            allow-create
                            clearable
                            placeholder="客户名称/电话"
                            :remote-method="searchCustom"
                            v-select-scroll-more="searchCustomLoad"
                        >
                            <el-option v-for="item in cusOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName">
                                <div class="name">
                                    {{ item.EntpCusName }}
                                    <span v-if="item.CallNum" class="phone">
                                        {{ ` ( 电话：${item.CallNum} )` }}
                                    </span>
                                </div>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="销售单号">
                        <el-input size="small" v-model.trim="searchData.OrderCode" v-filter-special-char="searchData.OrderCode" placeholder="销售单号"></el-input>
                    </el-form-item>
                    <el-form-item label="出库仓库" v-if="isExObj('WarehouseName')">
                        <el-select size="small" style="width: 100%" v-model="searchData.WarehouseId" filterable clearable @visible-change="wHVisibleChange($event)">
                            <el-option
                                v-for="optionItem in warehouseList"
                                :key="optionItem.WarehouseId"
                                :label="optionItem.WarehouseName"
                                :value="optionItem.WarehouseId"
                            >
                                <span style="float: left">{{ optionItem.WarehouseName }}</span>
                                <span v-if="optionItem.Type == 1" style="float: right; color: #8492a6; font-size: 13px">（前置仓）</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="支付方式" v-if="isExObj('PayTypeName')">
                        <el-select style="width: 100%" size="small" v-model="searchData.PayType" @visible-change="paytypeVisibleChange($event)">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="发货方式" v-if="isExObj('DeliTypeName')">
                        <el-select style="width: 100%" size="small" v-model="searchData.DeliType" @visible-change="delitypeVisibleChange($event)">
                            <el-option label="全部" value=""></el-option>
                            <el-option v-for="item in deliTypeList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单状态" v-if="isExObj('StateName')">
                        <el-select style="width: 100%" size="small" v-model="searchData.State">
                            <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开单部门" v-if="isExObj('OrgName')">
                        <el-select
                            size="small"
                            class="search-item"
                            style="width: 100%"
                            v-model="searchData.OrgId"
                            filterable
                            clearable
                            collapse-tags
                            reserve-keyword
                            @visible-change="orgVisibleChange($event)"
                            placeholder="请选择"
                        >
                            <el-option
                                v-for="optionItem in orgSearchData"
                                :key="optionItem.Id"
                                :data-msg="optionItem"
                                :label="optionItem.Name"
                                :value="optionItem.Id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="业务员" v-if="isExObj('SName')">
                        <el-select v-model="searchData.SId" size="small" style="width: 100%" filterable placeholder="请选择" clearable>
                            <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单来源" v-if="isExObj('CusSourcesName') && isUseSource">
                        <el-select style="width: 100%" size="small" v-model="searchData.CusSources" clearable @visible-change="cusSourceVisibleChange($event)">
                            <el-option v-for="item in cusSourceList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="备注" v-if="isExObj('Remark')">
                        <el-input size="small" v-model.trim="searchData.Remark" v-filter-special-char="searchData.Remark" placeholder="请输入单据备注信息"></el-input>
                    </el-form-item>
                    <el-form-item label="创建日期" v-if="isExObj('CreateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime1"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate1TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="更新日期" v-if="isExObj('UpdateTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime2"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate2TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="提交日期" v-if="isExObj('ConfirmTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime3"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate3TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="出库日期" v-if="isExObj('WHFinishTime')">
                        <el-date-picker
                            size="small"
                            style="width: 100%"
                            v-model="datetime4"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="onDate4TimeSelect"
                        ></el-date-picker>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button class="btn-primary" size="small" @click="handleSearch">查询（Enter）</el-button>
                    <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
                    <el-button size="small" @click="closeSearchDialog_N">关闭（Esc）</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import Vue from 'vue';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import printEngContent from '@/components/business/salesManage/printSalesEng';
import searchAP from '@/components/common/searchAP';
import ordersLifes from '@/components/common/ordersLifes';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    components: {
        printEngContent,
        searchAP,
        breadcrumb,
        elTableColumn,
        ordersLifes
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            summaryStr: '',
            sepStr: '',
            datetime1: [],
            datetime2: [],
            datetime3: [],
            datetime4: [],
            orgSearchData: [],
            deliTypeList: [], // 发货方式列表
            tableCode: 'EC-SaleOrderTable',
            userMsg: userMsg,
            multipleSelection: null,
            dialogVisible: false,
            showDisc: true,
            dialogPrintEngVisible: false,
            searchVisible: false,
            OrderId: '',
            OrderLifesVisible: false,
            priceCanBeEdit: false,
            idList: [],
            searchData: {
                PayType: '',
                State: '99',
                Keyword: '',
                SId: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                CStartDate: '',
                CEndDate: '',
                WStartDate: '',
                WEndDate: '',
                SortProp: '',
                SortType: '',
                WarehouseId: '',
                Remark: '',
                Source: '',
                CusSources: '',
                DeliType: '',
                OrgId: '',
                page: 1,
                limit: this.commonPageSize,
                CountryId: '',
                ShopId: ''
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
            payWayList: [],
            SIdList: [],
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '正常', Value: '99' },
                { Text: '未提交', Value: '0' },
                { Text: '已提交', Value: '40' },
                { Text: '未收款', Value: '5' },
                { Text: '已收款', Value: '10' },
                { Text: '未出仓', Value: '15' },
                { Text: '已出仓', Value: '20' },
                { Text: '已完成', Value: '30' },
                { Text: '已取消', Value: '25' },
                { Text: '已全部退货', Value: '35' }
            ],
            sourceList: [],
            cusSourceList: [],
            columnShowSets: [],
            // 用于客户名称列表，分页搜索
            cusOptions: [],
            cusForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            upLoading: false,
            headers: {
                'access-key': userMsg.Token,
                reqApp: 'yqgPC'
            },
            isDefaultSet: true, //是否使用浏览器的打印功能
            isPreview: false, //是否出现预览界面
            askShowDisc: false, //询问是否打印订单优惠价格
            isStartSearch: false,
            dialogSearchVisible: false,
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            isRegister: false,
            loading: false,
            isStopReq: false,
            isCheckPrice: false,
            warehouseList: [],
            isUseSource: false, //是否启用销售开单显示来源
            isDefaultStaff: true,
            countryList: [],
            shopList: []
        };
    },
    activated() {
        if (this.$store.state.needRefresh) {
            this.$store.commit('updateNeedRefresh', false);
            if (this.$store.state.orderData && this.$store.state.orderData.Id) {
                if (this.$store.state.orderData.Refresh) {
                    this.$store.commit('updateOrderList', { Id: '', IsAdd: false, Refresh: false });
                    this.resetSearch(true);
                    this.getTableData();
                } else this.getSingleData(this.$store.state.orderData, true);
            }
            //this.getTableData();
        }
        //切换页面的时候不会清除当前页面缓存，但是其他页面也有相同字段，会串页面数据，还是把数据清空了不要误导
        this.$refs.multipleTable.clearSelection();
        this.idList = [];
        this.multipleSelection = null;
        document.addEventListener('keydown', this.handleKeyEvent);
    },
    beforeRouteLeave(to, from, next) {
        document.removeEventListener('keydown', this.handleKeyEvent);
        if (this.dialogSearchVisible) this.dialogSearchVisible = false;
        next();
    },
    created() {
        this.getSetsData().then(() => {
            this.getConfigByCodes();
        });
    },
    mounted() {
        let that = this;
        that.permission = that.$util.getPermission('ecSalesOrder');
        //加载组件
        that.getPrintComponents();
    },
    watch: {
        isStartSearch(newVal, oldVal) {
            if (newVal === true) {
                this.$nextTick(() => {
                    this.$refs.search_cus.focus();
                });
            }
        }
    },
    methods: {
        handleKeyEvent(e) {
            let that = this;
            let key = window.event.keyCode;
            if (that.dialogVisible || that.dialogPrintEngVisible || that.searchVisible || that.OrderLifesVisible) return;
            //F1
            if (key === 112) {
                e.preventDefault();
            }
            //F2
            if (key === 113) {
                e.preventDefault();
                if (that.SIdList.length <= 1) that.getSIdList();
                that.dialogSearchVisible = true;
                that.isStartSearch = true;
                return;
            }
            //F3
            if (key === 114) {
                e.preventDefault();
                that.add(0);
            }
            //F4
            if (key === 115) {
                e.preventDefault();
            }
            if (key === 13) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.handleSearch();
                    that.isStartSearch = false;
                } else {
                    that.resetSearch();
                    that.getTableData();
                }
            }
            //ESC
            if (key === 27) {
                e.preventDefault();
                if (that.dialogSearchVisible) {
                    that.dialogSearchVisible = false;
                    that.isStartSearch = false;
                }
            }
            //右键
            if (key === 39) {
                e.preventDefault();
                if (!this.dialogSearchVisible) {
                    let page = that.searchData.page;
                    let limit = that.searchData.limit;
                    let totalPages = Math.ceil(that.tableDataLength / limit);
                    if (page < totalPages) {
                        that.searchData.page += 1;
                        that.getTableData();
                    }
                }
                return;
            }
            //左键
            if (key === 37) {
                e.preventDefault();
                if (!that.dialogSearchVisible) {
                    if (that.searchData.page !== 1) {
                        that.searchData.page -= 1;
                        that.getTableData();
                    }
                }
                return;
            }
        },
        getConfigByCodes() {
            let that = this;
            let codes = ['syllqdysz', 'xwdyxxdxxyh', 'dyyl', 'xgxsjg', 'djmrdtsj', 'ssckjbdylr', 'xsddly', 'ddlbmrbzsywy'];
            let isDefaultToday = false;
            that.$util.getSysConfigs(codes).then(data => {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        let code = data[i].Code;
                        let result = data[i].Result;
                        switch (code) {
                            case 'syllqdysz':
                                that.isDefaultSet = result;
                                break;
                            case 'xwdyxxdxxyh': //询问是否打印订单优惠价格
                                that.askShowDisc = result;
                                break;
                            case 'dyyl': //是否出现预览界面
                                that.isPreview = result;
                                break;
                            case 'xgxsjg':
                                that.priceCanBeEdit = result;
                                break;
                            case 'djmrdtsj':
                                isDefaultToday = result;
                                break;
                            case 'ssckjbdylr': //开启检查销售价的限制
                                that.isCheckPrice = result;
                                break;
                            case 'xsddly': //是否启用销售开单显示来源
                                that.isUseSource = result;
                                break;
                            case 'ddlbmrbzsywy':
                                that.isDefaultStaff = result;
                        }
                    }
                    if (isDefaultToday && that.isExObj('CreateTime')) {
                        //当前设定的日期时间
                        let d = new Date();
                        let year1, month1, day1;
                        [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
                        let date1 = new Date(year1, month1, day1, 0);
                        that.datetime1.push(date1);

                        //前一天设定的日期时间
                        let year2, month2, day2;
                        d.setTime(d.getTime());
                        [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
                        let date2 = new Date(year2, month2, day2, 0);
                        that.datetime1.unshift(date2);

                        that.searchData.StartDate = date2;
                        that.searchData.EndDate = date1;
                    }

                    if (that.isDefaultStaff) {
                        that.searchData.SId = that.userMsg.EmployeeId;
                    }
                }
                that.getTableData();
            });
        },
        //获取中文打印模板
        getPrintComponents() {
            let that = this;
            that.$util.getPrintComponents().then(data => {
                if (data) {
                    Vue.component('printSaleContent', () => import('@/components/printModels/' + data));
                    that.isRegister = true;
                } else {
                    Vue.component('printSaleContent', () => import('@/components/printModels/printSales'));
                    that.isRegister = true;
                }
            });
        },
        // 记录每行的key值
        getRowKeys(row) {
            return row.EntpCusOId;
        },
        // 客户名称列表，搜索
        async searchCustom(key) {
            if (![undefined].includes(key)) {
                this.cusForm.Page = 1;
                this.cusForm.stopLoad = false;
                this.cusForm.key = key;
                this.cusOptions = [];
            }
            if (this.cusForm.stopLoad) return;
            const data = await this.$util.searchCustomer(this.cusForm.key, this.cusForm.Page, this.cusForm.Limit);
            if (data) {
                if (!data) return;
                this.cusForm.stopLoad = data.length < this.cusForm.Limit;
                this.cusOptions = [...this.cusOptions, ...data];
            }
        },
        // 客户名称列表，加载更多
        searchCustomLoad() {
            this.cusForm.Page += 1;
            this.searchCustom();
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        },
        paytypeVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.payWayList.length == 0) that.getPay();
            }
        },
        delitypeVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.deliTypeList.length == 0) {
                    that.$util.getSendWay().then(data => {
                        that.deliTypeList = data;
                    });
                }
            }
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        showSearch() {
            this.searchVisible = true;
        },
        closeSearchDialog() {
            this.searchVisible = false;
        },
        // 跳转退货
        returns(row) {
            let searchParams = this.searchData;
            this.$util.setLocalStorage('ec_salesOrder_searchParams', searchParams); //保存当前查询参数，返回页面时使用
            this.$router.push(`/ecPlatform/ecReturnManage/edit?type=3&id=${row.EntpCusOId}`);
        },
        // 提交订单
        submitOrder(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要提交该销售单吗？',
                noMsg: true,
                confirm() {
                    if (that.isCheckPrice) {
                        that.checkPriceToConfirm(row);
                    } else {
                        that.submit(row);
                    }
                }
            });
        },
        submit(row) {
            let that = this;
            that.$util
                .axiosPost({
                    url: `/api/EntpSaleOrder/Submit_EC?OrderId=${row.EntpCusOId}`
                })
                .then(() => {
                    that.$util.successMsg('提交成功');
                    that.getSingleData({ Id: row.EntpCusOId, IsAdd: false }, false);
                });
        },
        checkPriceToConfirm(row) {
            let that = this;
            that.$util
                .axiosGet({
                    url: '/api/EntpSaleOrder/CheckGoodsForSaveByOId',
                    data: {
                        OrderId: row.EntpCusOId
                    }
                })
                .then(res => {
                    if (res.data.IsNeedPwd) {
                        let remark = res.data.Content;
                        that.$prompt(remark, '请输入管理员的密码', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            // inputPattern: /.{1,18}/,
                            inputType: 'password'
                            // inputErrorMessage: '请输入18字以内的数字或字母！'
                        })
                            .then(({ value }) => {
                                that.$util
                                    .axiosPost({
                                        url: 'api/EntpSaleOrder/AuthForSaveOrder',
                                        data: {
                                            Pwd: value,
                                            OrderId: row.EntpCusOId
                                        }
                                    })
                                    .then(res => {
                                        that.$util.successMsg('授权成功');
                                        that.submit(row);
                                    })
                                    .catch(() => {});
                            })
                            .catch(() => {});
                    } else that.submit(row);
                })
                .catch(() => {});
        },
        // 导出
        exportForm() {
            if (!this.idList[0]) {
                this.$util.warningMsg('请至少选择一条数据导出');
                return;
            }
            let EntpCusOIds = this.idList.join(',');
            this.$util.exportFile({
                url: '/api/EntpSaleOrder/ExportSaleOrder',
                data: {
                    EntpCusOIds: EntpCusOIds
                }
            });
        },
        exportEngForm() {
            if (!this.idList[0]) {
                this.$util.warningMsg('请至少选择一条数据导出');
                return;
            }
            let EntpCusOIds = this.idList.join(',');
            this.$util.exportFile({
                url: '/api/EntpSaleOrder/ExportSaleOrderEng',
                data: {
                    EntpCusOIds: EntpCusOIds
                }
            });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push(val[i].EntpCusOId);
            }
            this.idList = idList;
        },
        closeDialog(isPrint) {
            this.dialogVisible = false;
            if (isPrint) {
                this.tableData.forEach(item => {
                    if (item.EntpCusOId == this.idList[0]) {
                        item.PrintedCount += 1;
                        return;
                    }
                });
                this.$refs.multipleTable.clearSelection();
            }
        },
        closePrintEngDialog(isPrint) {
            this.dialogPrintEngVisible = false;
            if (isPrint) {
                this.tableData.forEach(item => {
                    if (item.EntpCusOId == this.idList[0]) {
                        item.PrintedCount += 1;
                        return;
                    }
                });
                this.$refs.multipleTable.clearSelection();
            }
        },
        // 打印预览
        printPreview() {
            if (!this.isDefaultSet) {
                let LODOP = this.$lodop.getLodop();
                if (!LODOP) return;
            }

            if (this.idList.length == 0) {
                this.$util.warningMsg('请选择一张销售单打印');
                return;
            } else if (this.idList.length > 1) {
                this.$util.warningMsg('只能选择一张销售单打印');
                return;
            }
            if (this.multipleSelection[0].StateName == '已取消') {
                this.$util.warningMsg('不能打印已取消的销售单');
                return;
            }
            if (this.multipleSelection[0].StateName == '未提交') {
                this.$util.warningMsg('不能打印未提交的销售单');
                return;
            }
            if (!this.askShowDisc || this.multipleSelection[0].DiscountAmount == 0) this.dialogVisible = true;
            else {
                this.showDisc = true;
                this.$confirm('是否打印显示优惠价？', '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning'
                })
                    .then(() => {
                        this.showDisc = true;
                        this.dialogVisible = true;
                    })
                    .catch(() => {
                        this.showDisc = false;
                        this.dialogVisible = true;
                    });
            }
        },
        print() {
            if (!this.isDefaultSet) {
                let LODOP = this.$lodop.getLodop();
                if (!LODOP) return;
            }

            if (this.idList.length == 0) {
                this.$util.warningMsg('请选择一张销售单打印');
                return;
            } else if (this.idList.length > 1) {
                this.$util.warningMsg('只能选择一张销售单打印');
                return;
            }
            if (this.multipleSelection[0].StateName == '已取消') {
                this.$util.warningMsg('不能打印已取消的销售单');
                return;
            }
            if (this.multipleSelection[0].StateName == '未提交') {
                this.$util.warningMsg('不能打印未提交的销售单');
                return;
            }
            if (!this.askShowDisc || this.multipleSelection[0].DiscountAmount == 0) this.$refs.printDom.init(true);
            else {
                this.showDisc = true;
                this.$confirm('是否打印显示优惠价？', '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning'
                })
                    .then(() => {
                        this.showDisc = true;
                        this.$refs.printDom.init(true);
                    })
                    .catch(() => {
                        this.showDisc = false;
                        this.$refs.printDom.init(true);
                    });
            }
        },
        // 打印英文版
        printEng() {
            if (this.idList.length == 0) {
                this.$util.warningMsg('请选择一张销售单打印');
                return;
            } else if (this.idList.length > 1) {
                this.$util.warningMsg('只能选择一张销售单打印');
                return;
            }
            if (this.multipleSelection[0].StateName == '已取消') {
                this.$util.warningMsg('不能打印已取消的销售单');
                return;
            }
            if (this.multipleSelection[0].StateName == '未提交') {
                this.$util.warningMsg('不能打印未提交的销售单');
                return;
            }
            this.dialogPrintEngVisible = true;
        },
        // 跳转编辑
        add(type, item) {
            let searchParams = this.searchData;
            this.$util.setLocalStorage('ec_salesOrder_searchParams', searchParams); //保存当前查询参数，返回页面时使用
            let id = item ? item.EntpCusOId : '';
            this.$router.push(`/ecPlatform/ecSalesOrder/edit?type=${type}&id=${id}`);
        },
        // 跳转历史配件销售
        history() {
            let searchParams = this.searchData;
            this.$util.setLocalStorage('ec_salesOrder_searchParams', searchParams); //保存当前查询参数，返回页面时使用
            this.$router.push('/ecPlatform/ecSalesOrder/histories');
        },
        cancel(row) {
            let that = this;
            that.$confirm('确定要取消该销售单吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                that.$util
                    .axiosPost({
                        url: `/api/EntpSaleOrder/CancelSaleOrder?OrderId=${row.EntpCusOId}`
                    })
                    .then(res => {
                        if (res.errcode == 0) {
                            that.$util.successMsg('取消成功！');
                            that.getSingleData({ Id: row.EntpCusOId, IsAdd: false }, true);
                        }
                    });
            });
        },
        // 删除销售单
        del(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该销售单吗？',
                noMsg: true,
                confirm() {
                    that.$util
                        .axiosPost({
                            url: `/api/EntpSaleOrder/DelSaleOrder?OrderId=${row.EntpCusOId}`
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('删除成功！');
                                let idx = that.tableData.findIndex(f => f.EntpCusOId === row.EntpCusOId);
                                that.tableData.splice(idx, 1);

                                that.tableDataLength -= 1;
                            }
                        });
                }
            });
        },
        resetSearch(setDay = false) {
            this.searchData = {
                PayType: '',
                State: '99',
                Keyword: '',
                SId: '',
                OrderCode: '',
                StartDate: '',
                EndDate: '',
                UStartDate: '',
                UEndDate: '',
                CStartDate: '',
                CEndDate: '',
                WStartDate: '',
                WEndDate: '',
                SortProp: '',
                SortType: '',
                WarehouseId: '',
                Remark: '',
                OrgId: '',
                Source: '',
                DeliType: '',
                CusSources: '',
                page: 1,
                limit: this.commonPageSize,
                CountryId: '',
                ShopId: ''
            };

            if (this.isDefaultStaff) {
                this.searchData.SId = this.userMsg.EmployeeId;
            }

            this.datetime1 = [];
            this.datetime2 = [];
            this.datetime3 = [];
            this.datetime4 = [];
            this.$refs.multipleTable.clearSelection();

            if (setDay) {
                //当前设定的日期时间
                let d = new Date();
                let year1, month1, day1;
                [year1, month1, day1] = [d.getFullYear(), d.getMonth(), d.getDate()];
                let date1 = new Date(year1, month1, day1, 0);
                this.datetime1.push(date1);

                //前一天设定的日期时间
                let year2, month2, day2;
                d.setTime(d.getTime());
                [year2, month2, day2] = [d.getFullYear(), d.getMonth(), d.getDate()];
                let date2 = new Date(year2, month2, day2, 0);
                this.datetime1.unshift(date2);

                this.searchData.StartDate = date2;
                this.searchData.EndDate = date1;
            }
        },
        getTableData() {
            if (!this.isStopReq) {
                this.loading = true;
                this.isStopReq = true;
                this.$util
                    .axiosGet({
                        url: '/api/EntpSaleOrder/GetList_EC',
                        data: this.searchData,
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        if (!data) data = [];
                        if (data.DataList) this.tableData = data.DataList;
                        else this.tableData = [];
                        if (this.searchData.page == 1) {
                            this.tableDataLength = res.count;
                            let exsum = this.isExObj('CalcAmount');
                            let exsep = this.isExObj('TotalBillingPrice');
                            if (exsum && exsep) {
                                this.summaryStr = data.SummaryStr + ' ；' + data.SepStr;
                            } else if (exsum) {
                                this.summaryStr = data.SummaryStr;
                            } else if (exsep) {
                                this.summaryStr = data.SepStr;
                            }
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                        this.isStopReq = false;
                    });
            }
        },
        handleSearch() {
            if (this.$refs.multipleTable) this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(event) {
            if (event) {
                let id = event.EntpCusOId;
                //保存当前查询参数，返回页面时使用
                this.$util.setLocalStorage('ec_salesOrder_searchParams', this.searchData);
                this.$router.push(`/ecPlatform/ecSalesOrder/check?id=${id}`);
            }
        },
        gotoImportCreatePage() {
            this.$router.push('/salesManage/salesOrder/importToCreateOrder');
        },
        opRecords(item) {
            let id = item ? item.EntpCusOId : '';
            if (id) {
                this.OrderId = id;
                this.OrderLifesVisible = true;
            } else {
                this.$util.warningMsg('订单数据异常，请刷新后重新操作');
            }
        },
        closeOrderLifesDialog() {
            this.OrderLifesVisible = false;
        },
        getSetsData() {
            return new Promise(resolve => {
                this.columnShowSets = [];
                this.$util
                    .getTBSetsForShow(this.tableCode)
                    .then(data => {
                        data.forEach(item => {
                            let colums = {
                                IsShow: item.IsShow,
                                Width: item.Width,
                                ColumnName: item.ColumnName,
                                ColumnCode: item.ColumnCode,
                                SortNum: item.SortNum,
                                IsSort: item.IsSort
                            };

                            this.columnShowSets.push(colums);
                        });
                        resolve();
                    })
                    .catch(err => {
                        resolve();
                    });
            });
        },
        sortChange(event) {
            this.searchData.SortProp = event.prop;
            this.searchData.SortType = event.order;
            this.searchData.page = 1;
            this.getTableData();
        },
        showSearchDialog() {
            if (this.SIdList.length <= 1) this.getSIdList();
            this.dialogSearchVisible = true;
            this.isStartSearch = true;
        },
        closeSearchDialog_N() {
            this.dialogSearchVisible = false;
            this.isStartSearch = false;
            // this.resetSearch();
        },
        //选中时间
        onDate1TimeSelect(val) {
            if (val != null) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onDate2TimeSelect(val) {
            if (val != null) {
                this.searchData.UStartDate = val[0];
                this.searchData.UEndDate = val[1];
            } else {
                this.searchData.UStartDate = '';
                this.searchData.UEndDate = '';
            }
        },
        onDate3TimeSelect(val) {
            if (val != null) {
                this.searchData.CStartDate = val[0];
                this.searchData.CEndDate = val[1];
            } else {
                this.searchData.CStartDate = '';
                this.searchData.CEndDate = '';
            }
        },
        onDate4TimeSelect(val) {
            if (val != null) {
                this.searchData.WStartDate = val[0];
                this.searchData.WEndDate = val[1];
            } else {
                this.searchData.WStartDate = '';
                this.searchData.WEndDate = '';
            }
        },
        wHVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.warehouseList.length == 0) {
                    that.$util.getWarehouse(1).then(data => {
                        that.warehouseList = data;
                    });
                }
            }
        },
        sourceVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.sourceList.length == 0) {
                    that.$util.getOrderSource().then(data => {
                        that.sourceList = data;
                    });
                }
            }
        },
        cusSourceVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.cusSourceList.length == 0) {
                    that.$util.getSalesOrderSources().then(data => {
                        if (data) {
                            that.cusSourceList = [...data, { Value: '-1', Text: '其他' }];
                        } else {
                            that.cusSourceList = [{ Value: '-1', Text: '其他' }];
                        }
                    });
                }
            }
        },
        orgVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.orgSearchData.length == 0)
                    that.$util.getParentOrgs().then(data => {
                        that.orgSearchData = data;
                    });
            }
        },
        downloadImg() {
            let that = this;
            let blob = that.$util.dataURLtoBlob(that.QRImg);
            const elink = document.createElement('a');
            // 设置下载文件名
            let orderData = that.tableData.find(e => e.QuoteId == that.idList[0]);
            let qCode = orderData.QCode;
            elink.download = `报价单二维码${qCode}.png`;
            elink.style.display = 'none';
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
        },
        isExObj(str) {
            let index = this.columnShowSets.findIndex(item => item.ColumnCode === str);
            return index > -1;
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                if (
                    column.property == 'CallNum' ||
                    column.property == 'SName' ||
                    column.property == 'OrderCode' ||
                    column.property == 'PayTypeName' ||
                    column.property == 'UpdateTime' ||
                    column.property == 'CreateTime' ||
                    column.property == 'ConfirmTime' ||
                    column.property == 'WHFinishTime'
                ) {
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                if (!values.every(value => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    let strL = sums[index] + '';
                    if (strL.indexOf('.') > -1) {
                        let str = strL.split('.')[1];
                        if (str.length > 2) {
                            sums[index] = sums[index].toFixed(2);
                        }
                    }
                } else {
                    sums[index] = '';
                }
            });

            return sums;
        },
        showOrderPreview(row) {
            this.idList = [];
            this.$refs.multipleTable.clearSelection();
            if (row) {
                this.idList.push(row.EntpCusOId);
                this.dialogVisible = true;
            }
        },
        getSingleData(param, isUpdate) {
            let that = this;
            that.$store.commit('updateOrderList', { Id: '', IsAdd: false });
            if (param.IsAdd && this.searchData.page == 1) {
                let topOrderId = that.tableData.length > 0 ? that.tableData[0].EntpCusOId : '';
                //获取单条数据，插入就行，删掉最后一条
                that.$util
                    .axiosGet({
                        url: '/api/EntpSaleOrder/GetSigleOrderData_EC',
                        data: {
                            PayType: that.searchData.PayType,
                            State: that.searchData.State,
                            Keyword: that.searchData.Keyword,
                            SId: that.searchData.SId,
                            OrderCode: that.searchData.OrderCode,
                            StartDate: that.searchData.StartDate,
                            EndDate: that.searchData.EndDate,
                            UStartDate: that.searchData.UStartDate,
                            UEndDate: that.searchData.UEndDate,
                            CStartDate: that.searchData.CStartDate,
                            CEndDate: that.searchData.CEndDate,
                            WStartDate: that.searchData.WStartDate,
                            WEndDate: that.searchData.WEndDate,
                            SortProp: that.searchData.SortProp,
                            SortType: that.searchData.SortType,
                            WarehouseId: that.searchData.WarehouseId,
                            Remark: that.searchData.Remark,
                            Source: that.searchData.Source,
                            CusSources: that.searchData.CusSources,
                            DeliType: that.searchData.DeliType,
                            OrgId: that.searchData.OrgId,
                            CountryId: that.searchData.CountryId,
                            ShopId: that.searchData.ShopId,
                            Id: param.Id,
                            IsUpdate: isUpdate,
                            TopOrderId: topOrderId,
                            Limit: that.searchData.limit
                        }
                    })
                    .then(res => {
                        if (res.data) {
                            if (res.data.DataList && res.data.DataList.length > 0) {
                                for (let index = 0; index < res.data.DataList.length; index++) {
                                    const element = res.data.DataList[index];

                                    let idx = that.tableData.findIndex(f => f.EntpCusOId === param.Id);
                                    if (idx == -1) {
                                        if (that.tableData.length == that.searchData.limit) that.tableData.splice(-1, 1);
                                        that.tableData.unshift(element);
                                    }
                                }
                                that.tableDataLength += res.data.DataList.length;
                            }
                            if (isUpdate) that.summaryStr = res.data.SummaryStr;
                        }
                    })
                    .catch(() => {});
            } else {
                //获取单条，更新
                that.$util
                    .axiosGet({
                        url: '/api/EntpSaleOrder/GetSigleOrderData_EC',
                        data: {
                            PayType: that.searchData.PayType,
                            State: that.searchData.State,
                            Keyword: that.searchData.Keyword,
                            SId: that.searchData.SId,
                            OrderCode: that.searchData.OrderCode,
                            StartDate: that.searchData.StartDate,
                            EndDate: that.searchData.EndDate,
                            UStartDate: that.searchData.UStartDate,
                            UEndDate: that.searchData.UEndDate,
                            CStartDate: that.searchData.CStartDate,
                            CEndDate: that.searchData.CEndDate,
                            WStartDate: that.searchData.WStartDate,
                            WEndDate: that.searchData.WEndDate,
                            SortProp: that.searchData.SortProp,
                            SortType: that.searchData.SortType,
                            WarehouseId: that.searchData.WarehouseId,
                            Remark: that.searchData.Remark,
                            Source: that.searchData.Source,
                            CusSources: that.searchData.CusSources,
                            DeliType: that.searchData.DeliType,
                            OrgId: that.searchData.OrgId,
                            CountryId: that.searchData.CountryId,
                            ShopId: that.searchData.ShopId,
                            Id: param.Id,
                            IsUpdate: isUpdate,
                            Limit: that.searchData.limit
                        }
                    })
                    .then(res => {
                        if (res.data) {
                            let idx = that.tableData.findIndex(f => f.EntpCusOId === param.Id);
                            that.tableData.splice(idx, 1, res.data.DataList[0]);

                            if (isUpdate) that.summaryStr = res.data.SummaryStr;
                        }
                    })
                    .catch(() => {});
            }
        },
        countryVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.countryList.length == 0) that.getCountryList();
            }
        },
        getCountryList() {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/Region/GetCountryList',
                        hideLoading: true
                    })
                    .then(res => {
                        this.countryList = res.data;
                        resolve();
                    })
                    .catch(() => {});
            });
        },
        countryChange(value) {
            this.searchData.CountryId = value;
        },
        shopVisibleChange(event) {
            let that = this;
            if (event) {
                that.$util.getPlatformShops().then(data => {
                    that.shopList = data;
                });
            }
        },
        shopChange(value) {
            this.searchData.ShopId = value;
        }
    }
};
</script>
<style lang="less" scoped>
#search-order-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .search-item-dialog {
        width: 340px;
        height: auto;

        .dialog-footer {
            text-align: right;
        }

        .el-form-item {
            margin-bottom: 0;
        }
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}

.codetag {
    font-size: 14px;
    border-style: none none none none;
    background-color: transparent;
    padding: 0;
    height: 11px;
    line-height: 12px;
    z-index: 999;
}
</style>
<style lang="less">
.sales-order-table {
    .el-table__row {
        td.ordercode-column {
            .cell {
                overflow: visible;
            }
        }
    }
}
</style>
